<template>
  <svg
    viewBox="0 0 44 34"
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="43"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 2C0 0.89543 0.89543 0 2 0H26C27.1046 0 28 0.89543 28 2V8H36C36.5304 8 37.0391 8.21071 37.4142 8.58579L41.0742 12.2458C42.0026 13.1752 42.7395 14.2791 43.2414 15.4931C43.7432 16.707 44.001 18.008 44 19.3216V26C44 27.1046 43.1046 28 42 28H39.9291C39.4439 31.3923 36.5265 34 33 34C29.4735 34 26.5561 31.3923 26.0709 28H19.9291C19.4439 31.3923 16.5265 34 13 34C9.47353 34 6.55612 31.3923 6.07089 28H2C0.89543 28 0 27.1046 0 26V2ZM28 22.101C29.2705 20.8045 31.0413 20 33 20C35.7924 20 38.2029 21.6351 39.3264 24H40V19.32C40.0006 18.5318 39.8459 17.7497 39.5448 17.0213C39.2438 16.2933 38.8024 15.6317 38.2458 15.0742L35.1716 12H28V22.101ZM24 24H19.3264C18.2029 21.6351 15.7924 20 13 20C10.2076 20 7.79709 21.6351 6.67363 24H4V4H24V24ZM13 24C11.3431 24 10 25.3431 10 27C10 28.6569 11.3431 30 13 30C14.6569 30 16 28.6569 16 27C16 25.3431 14.6569 24 13 24ZM30 27C30 25.3431 31.3431 24 33 24C34.6569 24 36 25.3431 36 27C36 28.6569 34.6569 30 33 30C31.3431 30 30 28.6569 30 27Z"
    />
  </svg>
</template>
